import React from "react";
import axios from "axios";
import Grid from '@mui/material/Grid';
import { Typography, Box } from '@mui/material';
import ActionAlert from '../../../../../../components/Alert/ActionAlert.jsx';
import CardMarkerSmall from '../../../../../../components/CockpitCards/CardMarkerSmall.jsx'
import * as c from '../../../../../../constants.jsx';
import TextCardBold from "../../../../../../components/TextComps/TextCardBold.jsx";
import TextCard from "../../../../../../components/TextComps/TextCard.jsx";
import TrafficLightIndicator from "../../../../../../components/TrafficLight/TrafficLightIndicator.jsx";
import InfoButton from "../../../../../../components/Button/InfoButton.jsx";
import Divider from '@mui/material/Divider';
import GetPhyla from "./GetPhyla.jsx";
import GetGenus from "./GetGenus.jsx";
import GetSpecies from "./GetSpecies.jsx";
import { useTheme } from "@mui/material";
import ButtonGeneGrey from '../../../../../../components/Button/ButtonGeneGrey'

export default function GetCompo() {

const theme = useTheme();

const url_compo = `${c.API_URL}/api/mcomposition`

const [compoInfo, setCompoInfo] = React.useState(null);
const [error, setError] = React.useState(null);

React.useEffect(() => {retrievePanel();}, []);

const retrievePanel = () => {
  axios
    .get(url_compo)
    .then((res) => {
      setCompoInfo(res.data);

    })
    .catch(function (error) {
      if (error.response) {
        // Request made and server responded
        setError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        setError("The request was made but no response was received.");
      } else {
        // Something happened in setting up the request that triggered an Error
        setError("Error: " + error.message);
      }
    });
};

return(
<>

{compoInfo ? 

 theme.palette.mode === "light" ? (

  <CardMarkerSmall

    headline = "COMPOSITION" 
    subtext = {"This section shows the overall structure of your mouth microbiome, including diversity, richness, evenness, and enterotype. While there is no single definition of a 'healthy' microbiome, we highlight the top phyla, genera, and species found in your sample to give insight into your mouth's microbial landscape.​"}

    cardlines = {<>

    {compoInfo.map((i, index) => 

      <Grid container sx={{mb:2, p:3, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  bgcolor: 'grey.C100', borderRadius: '10px', border: 'groove',   }}>

         <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="Entero Type" /> </Grid>
         <Grid size={2}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>  <ButtonGeneGrey name="TOP_GENUS" />  </Grid>
        <Grid size={4}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <TextCard textcard = { i.entero } /> </Grid>   
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <Box display="flex" alignItems="center"> <InfoButton tooltipText="Enterotype describes the main type of bacteria dominating your mouth." />   </Box> </Grid> 
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center',}}>   </Grid> 

     <Grid size={12}> <Divider role="presentation" sx={{mt:2, mb:2, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>

        <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="Species Diversity" /> </Grid>
        <Grid size={2}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <ButtonGeneGrey name={ i.diversity } /> </Grid>   
        <Grid size={4}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <TextCard textcard = "Ref: 1.5 - 3" /> </Grid>
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <Box display="flex" alignItems="center"> <InfoButton tooltipText="Species Diversity (Shannon Index): Species diversity, measured by the Shannon index, shows both how many different bacterial species are in your mouth and how evenly they are distributed. Healthy values typically range between 1.5 and 3. A higher Shannon index means a rich and balanced community of bacteria, which supports overall health. A lower index suggests less variety or dominance of a few species. Keeping your Shannon diversity in a healthy range helps maintain a strong and balanced mouth ecosystem." />   </Box> </Grid> 
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center',}}>   <TrafficLightIndicator value={i.diversity} lowThreshold="1.5" highThreshold="3" /> </Grid> 

        <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="Species Richness" /> </Grid>
        <Grid size={2}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <ButtonGeneGrey name= { i.richness } /> </Grid>   
        <Grid size={4}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <TextCard textcard = "Ref: 100 - 250" /> </Grid>
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <Box display="flex" alignItems="center"> <InfoButton tooltipText="Species richness counts how many different bacterial species are present in your mouth. Typical healthy values range from about 00 to 250 species." />   </Box> </Grid> 
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center',}}>   <TrafficLightIndicator value={i.richness} lowThreshold="100" highThreshold="250" /> </Grid> 

        <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="Species Evenness" /> </Grid>
        <Grid size={2}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <ButtonGeneGrey name= { i.eveness } /> </Grid>   
        <Grid size={4}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <TextCard textcard = "Ref: 0.5 - 0.8" /> </Grid>
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <Box display="flex" alignItems="center"> <InfoButton tooltipText="Species evenness shows how evenly the different bacterial species are distributed in your mouth. Healthy values usually range from 0.5 to 0.8. Higher evenness means bacteria are more balanced, with no single species dominating. Lower evenness means some bacteria outgrow others, which can lead to imbalances." />   </Box> </Grid> 
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center',}}>   <TrafficLightIndicator value={i.eveness} lowThreshold="0.5" highThreshold="0.8" /> </Grid> 

     <Grid size={12}> <Divider role="presentation" sx={{mt:2, mb:4, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>

       <Grid size={12} sx={{mb:2, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> <GetPhyla /> </Grid>
       <Grid size={12} sx={{mb:2, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> <GetGenus /> </Grid>
       <Grid size={12} sx={{mb:2, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> <GetSpecies /> </Grid>

 </Grid>    
)} 

  </>}  
/>

 ) : (

 <CardMarkerSmall

    headline = "COMPOSITION" 
    subtext = {"This section shows the overall structure of your gut microbiome, including diversity, richness, evenness, and enterotype. While there is no single definition of a 'healthy' microbiome, we highlight the top phyla, genera, and species found in your sample to give insight into your gut's microbial landscape."}

    cardlines = {<>

    {compoInfo.map((i, index) => 

      <Grid container sx={{mb:2, p:3, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  bgcolor: 'greydark.C800', borderRadius: '10px', border: 'groove', borderColor: 'greydark.C800'   }}>

        <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="Entero Type" /> </Grid>
        <Grid size={2}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>   <TextCard textcard = { i.entero } /> </Grid>   
        <Grid size={4}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>  <ButtonGeneGrey name="Type 1" />  </Grid>
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <Box display="flex" alignItems="center"> <InfoButton tooltipText="Enterotype describes the main type of bacteria dominating your gut. You may have a Bacteroides-type (common with high-protein, high-fat diets), a Prevotella-type (linked to high-fiber, plant-based diets), or a Ruminococcus-type (involved in breaking down complex carbs and mucus). Each type shows how your gut digests food. For example, Bacteroides helps with protein and fat, Prevotella with fiber, and Ruminococcus with complex carbs. This can guide diet choices for better gut health." />   </Box> </Grid> 
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center',}}>   </Grid> 

     <Grid size={12}> <Divider role="presentation" sx={{mt:2, mb:2, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>

        <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="Species Diversity" /> </Grid>
        <Grid size={2}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <ButtonGeneGrey name={ i.diversity } /> </Grid>   
        <Grid size={4}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <TextCard textcard = "Ref: 3.5 - 5.5" /> </Grid>
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <Box display="flex" alignItems="center"> <InfoButton tooltipText="Species Diversity (Shannon Index): Species diversity, measured by the Shannon index, shows both how many different bacterial species are in your gut and how evenly they are distributed. Healthy values typically range between 3.5 and 5.5. A higher Shannon index means a rich and balanced community of bacteria, which supports good digestion and overall health. A lower index suggests less variety or dominance of a few species, which can be linked to gut problems or disease risk. Keeping your Shannon diversity in a healthy range helps maintain a strong and balanced gut ecosystem." />   </Box> </Grid> 
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center',}}>   <TrafficLightIndicator value={i.diversity} lowThreshold="3.5" highThreshold="5.5" /> </Grid> 

        <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="Species Richness" /> </Grid>
        <Grid size={2}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <ButtonGeneGrey name= { i.richness } /> </Grid>   
        <Grid size={4}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <TextCard textcard = "Ref: 200 - 600" /> </Grid>
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <Box display="flex" alignItems="center"> <InfoButton tooltipText="Species richness counts how many different bacterial species are present in your gut. Typical healthy values range from about 200 to 600 species. Higher richness means your gut has many different bacteria, which usually supports better digestion and a stronger immune system. Lower richness can indicate fewer bacteria types, which may make your gut less resilient and more prone to issues. A rich variety of species helps keep your gut balanced and healthy." />   </Box> </Grid> 
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center',}}>   <TrafficLightIndicator value={i.richness} lowThreshold="200" highThreshold="600" /> </Grid> 

        <Grid size={4} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="Species Evenness" /> </Grid>
        <Grid size={2}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <ButtonGeneGrey name= { i.eveness } /> </Grid>   
        <Grid size={4}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <TextCard textcard = "Ref: 0.6 - 0.9" /> </Grid>
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <Box display="flex" alignItems="center"> <InfoButton tooltipText="Species evenness shows how evenly the different bacterial species are distributed in your gut. Healthy values usually range from 0.6 to 0.9. Higher evenness means bacteria are more balanced, with no single species dominating. This balance supports a stable and healthy gut. Lower evenness means some bacteria outgrow others, which can lead to imbalances and gut problems. Keeping evenness in a healthy range helps maintain a steady and diverse microbiome." />   </Box> </Grid> 
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center',}}>   <TrafficLightIndicator value={i.eveness} lowThreshold="0.6" highThreshold="0.9" /> </Grid> 

     <Grid size={12}> <Divider role="presentation" sx={{mt:2, mb:4, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>

       <Grid size={12} sx={{mb:2, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> <GetPhyla /> </Grid>
       <Grid size={12} sx={{mb:2, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> <GetGenus /> </Grid>
       <Grid size={12} sx={{mb:2, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> <GetSpecies /> </Grid>

 </Grid>    
)} 

  </>}  
/>

 )

 : 

    <Grid mt={2} mb={2} justifyContent="center" container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
        <ActionAlert
            severity="warning"
            message={"Currently no information available"}
        />
        </Grid>
    </Grid>

}

{error && (
          <Grid mt={2} mb={1} justifyContent="center" container spacing={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <ActionAlert severity="error" message={error.message} />
            </Grid>
          </Grid>
)}

</> 
)
}

